import React from "react";
import { Card, CardContent } from "../../../components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../../../components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";


interface NewsFeedItem {
  title: string;
  description: string;
  image: string;
  link: string;
}

interface NewsProps {
  source: {
    id?: number;
    name?: string;
  };
  author?: string;
  title?: string;
  description?: string;
  url?: string;
  urlToImage?: string;
  publishedAt?: string;
  content?: string;
}

interface NewsFeedProps {
  newsItems: NewsProps[];
  title?: string;
  description?: string;
}

export default function NewsFeed({ newsItems, title="In The News", description="Stay updated with the latest news and developments in wildlife conservation." }: NewsFeedProps) {
  return (
    <section className="w-full py-8 bg-white">
      <div className="mx-auto lg:max-w-6xl px-4">
        <h2 className="text-2xl font-bold text-green-800 mb-6">{title}</h2>
        <p className="text-green-700 mb-4">
          {description}
        </p>
        <Carousel
            opts={{
              loop: true,
              align: "start",
            }}
            plugins={[
              Autoplay({
                delay: 3000,
              }),
            ]}
        >
          <CarouselContent>
            {Array.isArray(newsItems) && newsItems.map((item, index) => (
              <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                <Card className="shadow-md bg-green-50">
                  <img
                    src={item.urlToImage}
                    alt={item.title}
                    className="w-full h-48 object-cover rounded-t-lg"
                  />
                  <CardContent className="p-4">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-gray-600 mb-4">
                      {item.description}
                    </p>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-green-600 hover:underline"
                    >
                      Read more
                    </a>
                  </CardContent>
                </Card>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="absolute left-[-50px] top-1/2 -translate-y-1/2 fill-green-800" />
          <CarouselNext className="absolute right-[-50px] top-1/2 -translate-y-1/2 fill-green-800" />
        </Carousel>
      </div>
    </section>
  );
}